import { useEffect, useState, useCallback } from 'react'

export const useGetGeoLocation = (fetchOnMount = false) => {
  const [position, setPosition] = useState()
  const [error, setError] = useState()
  const [fetchingPosition, setFetchingPosition] = useState(false)
  const [shouldFetchOnMount, setShouldFetchOnMount] = useState(fetchOnMount)

  const getGeolocation = useCallback(() => {
    setShouldFetchOnMount(true)
  }, [])

  useEffect(() => {
    const options = {
      enableHighAccuracy: true,
      timeout: Infinity,
      maximumAge: 0,
    }

    if (!shouldFetchOnMount) return
    let canceled = false
    setFetchingPosition(true)
    navigator.geolocation.getCurrentPosition(
      position => {
        setFetchingPosition(false)
        if (!canceled) {
          setPosition(position)
        }
      },
      error => {
        setFetchingPosition(false)
        if (!canceled) {
          setError(error)
        }
      },
      options
    )

    return () => {
      canceled = true
    }
  }, [shouldFetchOnMount])

  return {
    getGeolocation,
    longitude: position?.coords?.longitude,
    latitude: position?.coords?.latitude,
    geoError: error,
    fetchingPosition,
  }
}
